'use strict';

angular.module('userRequestEditControllers')

.controller('NotEnoughPrivilegesController', ['$scope', '$state', 'editAccessRequestService', function ($scope, $state, service) {

    $scope.expirationMaxDate = moment().add(1, 'years').calendar();

    $scope.addAuthorizationException = function (isValid) {
        if (isValid) {
            var requestId = this.userRequest.UserAccessRequestID;
            var systemRoleId = this.notEnoughRightsSysRole.SystemRoleID;

            var now = moment();
            var expirationDateObj = moment(this.exceptionExpirationDate);

            var completeJustification = 'The employee\'s direct supervisor cannot authorize role "' +
                                        '"' + this.notEnoughRightsSysRole.SystemRoleName + '" in ' + this.notEnoughRightsSysRole.SystemName + '.' +
                                        '\n' +
                                        now.format('YYYY-MM-DD') +
                                        ' - Exception by ' + this.authenticatedUser.IdentityName +
                                        ' valid until ' + expirationDateObj.format('MMMM DD, YYYY') + ': ' +
                                        '\n' +
                                        this.exceptionJustification;

            service.systemRolePendings.addAuthorizationExceptionForSupervisor(requestId, systemRoleId,
                                                                              completeJustification,
                                                                              this.exceptionExpirationDate)
            .then(function () {
                $state.reload();
            });
        }
    }
}]);